import styles from "./SpinLoader.module.scss";

const WhiteSpinnerLoader: React.FC = () => {
  return (
    <div className={styles.whiteLoader}></div>
  );
};

export default WhiteSpinnerLoader;
